import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ProductReviews } from './ProductReviews';

export const ProductReviewsContainer = () => {
  return (
    <QueryProvider cacheKey="paginated-product-reviews">
      <ProductReviews />
    </QueryProvider>
  );
};
